import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';

/**
 * Description
 * @param {object} props
 * @param {object} props.tariff
 * @returns {React.ReactComponentElement} - AdminMeterShowTariff component
 */
function AdminMeterShowTariff({ tariff = null }) {
  if (!tariff) {
    return <tr><td aria-label="loading" colSpan={4}><Loading /></td></tr>;
  }

  const {
    uuid, identifier, active, meter,
  } = tariff;
  const { uuid: meterId } = meter;

  return (
    <tr key={`tariff-${uuid}`}>
      <th scope="row" className="text-right">
        <UUID uuid={uuid} url={`/admin/tariffs/${uuid}`} />
      </th>
      <td>{identifier}</td>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
      <td>
        <UUID uuid={meterId} />
      </td>
    </tr>
  );
}

AdminMeterShowTariff.propTypes = {
  tariff: PropTypes.shape({
    uuid: PropTypes.string,
    identifier: PropTypes.string,
    active: PropTypes.shape({
      start: PropTypes.number,
      finish: PropTypes.number,
    }),
    meter: PropTypes.shape({
      uuid: PropTypes.string,
    }),
  }),
};

export default AdminMeterShowTariff;
